import { useCallback, useMemo, type ReactNode } from "react";
// @ts-expect-error pure js
import useProfileBailleurs from "../hooks/use-profile-bailleurs";
import { buildProfileRights, profileCanWrite } from "../utils/permissions";
import type { ProfileBailleur } from "../components/Profile/types";
import { ProfileRightsContext } from "./profile-rights-context";

// Exposes the current user's effective write rights per landlord profile,
// derived from GET /profiles. Mount inside AuthProvider (it fetches profiles,
// which requires auth). Consumers use the useCanWrite hook.
export default function ProfileRightsProvider({
  children,
}: {
  children: ReactNode;
}) {
  const { profileBailleurs } = useProfileBailleurs() as {
    profileBailleurs: ProfileBailleur[];
  };

  const rights = useMemo(
    () => buildProfileRights(profileBailleurs ?? []),
    [profileBailleurs],
  );

  const canWrite = useCallback(
    (profileId?: number | null) => profileCanWrite(rights, profileId),
    [rights],
  );

  return (
    <ProfileRightsContext.Provider value={canWrite}>
      {children}
    </ProfileRightsContext.Provider>
  );
}
